import type { ViewToggleItem } from '../types/menu-items'
import type { MenubarViewToggles } from '../types/menubar-view-toggles'

export interface ViewToggleGroups {
  /** Snap to Grid (sits under the Show Grid submenu) */
  grid: ViewToggleItem[]
  /** Show Guides, Smart Guides, Snap to Guides (followed by Set Columns & Rows Guides) */
  guides: ViewToggleItem[]
  /** Show Bleed Bar, Show Text Linking, Show Sticky Notes */
  overlays: ViewToggleItem[]
}

/** View-menu checkbox rows shared by the desktop dropdown and the mobile sheet. */
export function buildViewToggleItems(toggles: MenubarViewToggles): ViewToggleGroups {
  return {
    grid: [{ label: 'Snap to Grid', checked: toggles.snapToGrid, set: toggles.setSnapToGrid }],
    guides: [
      { label: 'Show Guides', checked: toggles.showGuides, set: toggles.setShowGuides },
      {
        label: 'Smart Guides',
        checked: toggles.showSmartGuides,
        disabled: !toggles.showGuides,
        set: toggles.setShowSmartGuides,
      },
      {
        label: 'Snap to Guides',
        checked: toggles.snapToGuides,
        disabled: !toggles.showGuides,
        set: toggles.setSnapToGuides,
      },
    ],
    overlays: [
      { label: 'Show Bleed Bar', checked: toggles.showBleedBar, set: toggles.setShowBleedBar },
      {
        label: 'Show Text Linking',
        checked: toggles.showTextLinking,
        set: toggles.setShowTextLinking,
      },
      {
        label: 'Show Sticky Notes',
        checked: toggles.showStickyNotes,
        set: toggles.setShowStickyNotes,
      },
    ],
  }
}
